import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";

export default function Forbidden() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-[#0A0A0A] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-[#FFF1F1] border border-[#FEE2E2] flex items-center justify-center mb-6 shadow-soft-red">
          <ShieldX className="w-7 h-7 text-[#DC2626]" />
        </div>
        <div className="font-mono text-sm text-[#9B9B9B] mb-2">ERROR 403</div>
        <h1 className="font-display font-bold text-3xl tracking-tight mb-2">Acesso negado</h1>
        <p className="text-[#6B6B6B] mb-8">Esta área é restrita ao seu perfil de usuário.</p>
        <Link to="/">
          <Button className="bg-[#DC2626] hover:bg-[#B91C1C] glow-red rounded-full px-6">Voltar ao início</Button>
        </Link>
      </div>
    </div>
  );
}
